import { Outlet, Link } from "react-router-dom";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink
  } from '@chakra-ui/react'

const Game = () => {
    return (
        <>
            <Breadcrumb separator='-'>
                <BreadcrumbItem>
                    <BreadcrumbLink isCurrentPage as={Link} to='/'>Home</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                    <BreadcrumbLink as={Link} to='/Overview'>Overview</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <BreadcrumbLink as={Link} to='/BoxOne'>Box One</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <BreadcrumbLink as={Link} to='/BoxTwo'>Box Two</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <BreadcrumbLink as={Link} to='/BoxThree'>Box Three</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <BreadcrumbLink as={Link} to='/Conclusion'>Conclusion</BreadcrumbLink>
                </BreadcrumbItem>
            </Breadcrumb>

            <Outlet />
        </>
    )
};

export default Game;
